import { render } from "./GalleryLightbox.vue?vue&type=template&id=1d9fdd39&scoped=true"
import script from "./GalleryLightbox.vue?vue&type=script&lang=js"
export * from "./GalleryLightbox.vue?vue&type=script&lang=js"

import "./GalleryLightbox.vue?vue&type=style&index=0&id=1d9fdd39&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9fdd39"]])

export default __exports__